import React from 'react';
import { Page, PageHeader, PageBody } from "../base/Page";
import { browserHistory } from "react-router";
import { Button, Row, Col, Panel, FormGroup, ControlLabel } from 'react-bootstrap';
import API from "../base/API";
import Auth from "../auth/Auth";
import FormField from "../base/FormField";
import DataSelectTable from "../base/DataSelectTable";
import { translate, languages } from "../base/Translation";
import SorTable from "../base/SorTable";
import { getUser } from "../auth/Auth";
import UserAgreementEdit from "./UserAgreementEdit"
import StarRatingComponent from 'react-star-rating-component';

export default class UserEdit extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			save_user: "/user/save/:id",
			fetch_user: "/user/fetch/:id",
			fetch_fields: "/user/fetch/fields/:role",
			get_brands: "/brand/fetch/all",
			get_tests_by_external: "/test/fetch/by/external/:user"
		});

		// Experimental: Use passive data instead of state
		// To reduce re-rendering
		this.user = false;

		this.state = {
			loaded: false,
			fields: [],
			tests: [],
			roles: [
				{ key: 1, value: "UNAUTHORIZED" },
				{ key: 2, value: "Prevádzka / Dealer" },
				{ key: 3, value: "Klient / Importér" },
				{ key: 4, value: "Externý používateľ" },
				{ key: 5, value: "TOPTEST" },
				{ key: 6, value: "Admin" },
				{ key: 7, value: "Super Admin" }
			],
			brands: [],
			tableColumns: [
				{ name: "select", display: "#", sort: true, width: 5 },
				{ name: "name", display: translate("Značka"), sort: true, width: 95 },
			],
			rewardTableColumns: [
				{ name: "test", display: translate("Návšteva"), sort: true, width: 40 },
				{ name: "date", display: translate("Dátum"), sort: true, width: 25 },
				{ name: "reward", display: translate("Odmena"), sort: true, width: 20 },
				{ name: "rating", display: translate("Hodnotenie"), sort: true, width: 15 },
			]
		};
	}

	componentDidMount() {
		this.fetch();
	}

	convertDataForRewardTable(data) {
		return data.map(function (item) {
			let data = {};

			data.test = item.test.name;
			data.date = item.test.date;
			data.reward = item.reward;
			data.rating = <StarRatingComponent
				name={"test_" + item.test.id}
				starCount={5}
				editable={true}
				value={parseInt(item.rating, 10)}
				onStarClick={this.onStarClick.bind(this)}
			/>;

			return data;
		}.bind(this));
	}

	fetch() {
		this.api.request({
			route: "fetch_user",
			params: { id: this.props.params.userID },
			success: (response) => {
				this.user = response;
				this.fetchFields(this.user.role);
				this.api.request({
					route: "get_brands",
					success: (response) => {
						this.setState({ brands: response });
					}
				});

				if (this.user.role === 4) {
					this.api.request({
						route: "get_tests_by_external",
						params: { user: this.user.id },
						success: (response) => {
							this.setState({ tests: response });
						}
					});
				}

			}
		});

	}

	getAverageRating() {
		let total = 0;
		
		this.user.external_test_log.forEach((item, index) => {
			total += parseInt(item.rating, 10);
		});

		return total === 0 ? 0 : total / this.user.external_test_log.length;
	}

	onStarClick(value, someVar, name) {

		this.user.external_test_log.map((item, index) => {
			if ("test_" + item.test.id === name) {
				item.rating = value;
			}
			return item;
		});

		this.forceUpdate();
	}

	save(evt) {
		this.api.request({
			route: "save_user",
			params: { id: this.user.id },
			data: this.user,
			created: (response) => {
				browserHistory.push("/users");
			}
		});
	}

	fetchFields(role) {
		if (parseInt(role, 10) === 0) {
			//this.user.meta = [];			
			this.setState({ fields: [] });
			return;
		}

		this.api.request({
			route: "fetch_fields",
			params: { role: role },
			success: (response) => {
				//this.user.meta = response;
				this.setState({ fields: response });
			}
		});
	}

	onChange(evt) {

		if (evt.target.name === "role") {
			this.fetchFields(evt.target.value);
		}

		let user = this.user;
		user[evt.target.name] = evt.target.value;
		this.user = user;
	}

	onMetaChange(evt) {
		let user = this.user;
		user.meta[evt.target.name] = evt.target.value;
		this.user = user;
	}

	onTableSelect(index, selected) {
		this.user.brands = selected;
		this.setState({ user: this.user });
	}

	renderAvgRating() {
		return (

			<StarRatingComponent
				name="average_rating"
				starCount={5}
				editable={false}
				value={Math.round(this.getAverageRating())}
			/>

		)
	}

	userLog() {
		if (this.user.role !== 4) {
			return "";
		}

		return (
			<Col lg={6}>
				<Panel header={translate("Záznam činností / Odmeny / Hodnotenie")}>
					<strong style={{ paddingLeft: "0.5rem" }}>{translate("Priemerné hodnotenie")}: {Math.round(this.getAverageRating())}/5</strong>
					<SorTable columns={this.state.rewardTableColumns} search={false} data={this.convertDataForRewardTable(this.user.external_test_log)} headers={true} />
				</Panel>
			</Col>
		)
	}

	renderUserNote() {
		if (getUser().role < 5) {
			return "";
		}

		return (
			<FormGroup>
				<ControlLabel>{translate("Poznámka")}</ControlLabel>
				<textarea name="note" className="form-control" defaultValue={this.user.note} onChange={this.onChange.bind(this)} />
			</FormGroup>
		)
	}

	renderUserAgreement() {
		if (this.user.role !== 4) {
			return "";
		}

		return (
			<Col lg={6}>
				<UserAgreementEdit user={this.user} />
			</Col>
		)
	}

	render() {
		if (this.user === false) {
			return (
				<Page>
					<PageHeader>{translate("Prosím počkajte")}</PageHeader>
					<PageBody>{translate("Obsah sa načítava")}</PageBody>
				</Page>
			);
		}

		return (
			<Page>
				<PageHeader title={translate("Údaje používateľa")} />
				<PageBody>
					<Row>
						<Col lg={6}>
							<Panel header={translate("Profil")}>
								{this.state.fields.map(function (field) {
									return <FormField key={field} type="text" title={translate(field)} name={field} value={this.user.meta[field]} onChange={this.onMetaChange.bind(this)} />
								}.bind(this))}
								{this.renderUserNote()}
							</Panel>
						</Col>
						<Col lg={6}>
							<Panel header={translate("Prihlasovacie údaje")}>
								<FormField type="text" title={translate("E-mail")} name="email" readOnly={false} value={this.user.email} onChange={this.onChange.bind(this)} />
								<FormField type="password" title={translate("Heslo")} name="password" value={typeof this.user.password !== "undefined" ? this.user.password : ""} onChange={this.onChange.bind(this)} />
								<FormField type="select" title={translate("Jazyk")} name="language" value={this.user.language} onChange={this.onChange.bind(this)} options={languages} />
								<FormField type="select" title={translate("Rola")} name="role" value={this.user.role} onChange={this.onChange.bind(this)} options={this.state.roles} />
							</Panel>
						</Col>
					</Row>
					<Row>
						<Col lg={6}>
							<Panel header={translate("Značky")}>
								<DataSelectTable
									tableColumns={this.state.tableColumns}
									data={this.state.brands}
									selected={this.user.brands}
									onChange={this.onTableSelect.bind(this)} />
							</Panel>
						</Col>
						{this.userLog()}
						{this.renderUserAgreement()}
					</Row>
					<Row>
						<Col lg={12}>
							<FormGroup>
								<Button bsStyle="success" onClick={this.save.bind(this)}>{translate("Uložiť")}</Button>
							</FormGroup>
						</Col>
					</Row>
				</PageBody>
			</Page>
		);
	}
}


// WEBPACK FOOTER //
// ./src/modules/user/UserEdit.js